import { GET_PBI_URL } from 'src/constants';
import { axios } from 'src/lib';

// eslint-disable-next-line import/prefer-default-export
export function fetchPowerBIUrlForPage(
  sourceId: number,
  pageId: string
): Promise<{ data: { embed_url: string } }> {
  return axios.get(`${GET_PBI_URL}${sourceId}/${pageId}/`);
}
